export const AUTH_TOKEN_KEY = 'whapbuss_token';

export function getStoredAccessToken(): string | null {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function setStoredAccessToken(token: string): void {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function clearStoredAccessToken(): void {
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

export function authHeadersJson(): HeadersInit {
  const token = getStoredAccessToken();
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export function authHeadersForMultipart(): HeadersInit {
  const token = getStoredAccessToken();
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}

export function authHeadersForGet(): HeadersInit {
  const token = getStoredAccessToken();
  const headers: Record<string, string> = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
}
